import { FC } from 'react';
import { styled } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { Dialog } from '../Dialog';
import { CrossInCircleIcon } from '../Icons';
import { CalculatorDialogProps } from './types';
import { colors } from 'variables';
import { links } from './helpers';

const StyledDialog = styled(Dialog)(() => ({
  '& .MuiDialog-paper': {
    borderRadius: '1.4rem',
    padding: '3.3rem 2.5rem',

    ul: {
      margin: 0,
      padding: 0,
    },
  },
}));

export const CalculatorDialog: FC<CalculatorDialogProps> = ({ onClose, open }) => {
  const handleClose = () => {
    onClose();
  };

  return (
    <StyledDialog onClose={handleClose} open={open}>
      <CrossInCircleIcon className={'absolute top-5 right-5'} color={colors.primary} onClick={handleClose} />
      <ul>
        {links.map(({ labelKey, url, icon, isSeparated }) => (
          <div key={labelKey}>
            <li className={'list-none px-3 py-2'}>
              <a
                href={url}
                className={'font-satoshiMedium text-ash flex items-center text-lg font-medium no-underline'}
              >
                {icon}
                <span className={'ml-2'}>
                  <FormattedMessage id={labelKey} />
                </span>
              </a>
            </li>
            {isSeparated && (
              <div className='border-purply my-3 h-px w-full border-x-0 border-t-0 border-b border-solid' />
            )}
          </div>
        ))}
      </ul>
    </StyledDialog>
  );
};
